import { HeaderLink } from './header.interface';

export interface HeaderState {
   breadcrumbs: Array<HeaderLink>;
   tabs: Array<HeaderLink>;
}

const state: HeaderState = {
   breadcrumbs: [{ to: '/', content: 'NxtForm' }],
   tabs: [],
};

const getters = {
   breadcrumbs(state: HeaderState) {
      return state.breadcrumbs;
   },
   tabs(state: HeaderState) {
      return state.tabs;
   },
};

const mutations = {
   SET_BREADCRUMBS(state: HeaderState, breadcrumbs: Array<HeaderLink>) {
      state.breadcrumbs = [{ to: '/', content: 'NxtForm' }, ...breadcrumbs];
   },
   SET_TABS(state: HeaderState, tabs: Array<HeaderLink>) {
      state.tabs = tabs;
   },
};

const actions = {};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
